// "Start a new chat from here" on a published story board (DataViz web app):
// the host's own button, so it works on a plain story page that never talks
// to the host. Disabled with its reason when the viewer may not start chats.
import React from 'react'
import { Button, type SxProps, type Theme } from '@mui/material'
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined'
import DisabledReason from '../system/DisabledReason'

export interface StartChatFromPageButtonProps {
  onStart: () => void
  /** Why the viewer cannot start a chat from here. */
  reason?: string
  /** The answer is not known yet (AI access loading). */
  pending?: boolean
  variant?: 'outlined' | 'contained'
  sx?: SxProps<Theme>
}

export default function StartChatFromPageButton({ onStart, reason, pending, variant = 'outlined', sx }: StartChatFromPageButtonProps) {
  return (
    <DisabledReason reason={reason}>
      <Button
        size="small"
        variant={variant}
        color="info"
        startIcon={<AddCommentOutlinedIcon fontSize="small" />}
        onClick={onStart}
        disabled={pending}
        data-testid="dashboard-start-chat"
        sx={{ textTransform: 'none', ...sx }}
      >
        Start a new chat from here
      </Button>
    </DisabledReason>
  )
}
